<template>
  <button
    class="btn btn__color--prim btn__size--full-6 align--center"
    :disabled="isLoading || loader"
  >
    <span
      class="d-flex align-items-center justify-content-center"
      v-if="isLoading"
    >
      <app-spinner
        class="margin__r--6"
        size="2"
      />

      {{ t('literal.signing_in_with_your_x_account', { x: provider }) }}
    </span>

    <template v-else>
      <slot
        :provider="provider"
        :text="text"
      >
        {{ text }}
      </slot>
    </template>
  </button>
</template>

<script setup>
import { computed, defineAsyncComponent } from 'vue'
import { storeToRefs } from 'pinia'
import { useSsoStore } from '@/stores/SsoStore'
import { useI18n } from '@/vendors/i18n'

const AppSpinner = defineAsyncComponent(() => import('&/atoms/AppSpinner'))

const { provider } = defineProps({
  provider: { type: String, required: true },
  isLoading: { type: Boolean, default: false }
})

const { t } = useI18n()
const { loader } = storeToRefs(useSsoStore())

const text = computed(() => t('literal.login_with_your_x_account', { x: provider }))
</script>

<style scoped lang="scss">
.btn {
  color: $white;
  position: relative;
  padding-inline: 24px;

  &:disabled {
    background-color: $vlg !important;
    color: $mg;
    cursor: default;

    &:hover {
      background-color: $vlg;
      color: $mg;
    }
  }
}
</style>